/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { calculatorHistoryGetResponseSchema } from './calculatorHistoryGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getCalculatorHistory200Schema = z.lazy(() => calculatorHistoryGetResponseSchema);

/**
 * @description 505 response
 */
export const getCalculatorHistory505Schema = z.any();

export const getCalculatorHistoryQueryResponseSchema = z.lazy(() => getCalculatorHistory200Schema);
